import { scheduleBillingQueryInvalidations } from './billingReconciliationQueryInvalidation.js';

const rowsFromPayload = (payload) => (Array.isArray(payload) ? payload : payload?.rows || []);

const withRows = (payload, rows) => {
  if (Array.isArray(payload)) return rows;
  if (payload && typeof payload === 'object') {
    return {
      ...payload,
      rows,
      total: payload.total,
      returned: payload.returned !== undefined ? rows.length : payload.returned,
    };
  }
  return payload;
};

export const reconcileLifecycleAlertCaches = (queryClient, data, variables = {}) => {
  const id = data?.id || variables?.id;
  if (!id) return;
  const dismissed = variables?.patch?.dismissed !== false;
  queryClient.getQueryCache()
    .findAll({ queryKey: ['billingRecon', 'lifecycleAlerts'] })
    .forEach((query) => {
      queryClient.setQueryData(query.queryKey, (current) => {
        const rows = rowsFromPayload(current);
        if (!rows.length) return current;
        const nextRows = dismissed
          ? rows.filter((row) => row.id !== id)
          : rows.map((row) => (row.id === id ? { ...row, ...data, dismissedAt: null } : row));
        return withRows(current, nextRows);
      });
    });
};

export const scheduleLifecycleDependents = (queryClient, variables = {}) => {
  const specs = [['billingRecon', 'lifecycleAlerts']];
  if (variables?.runId) {
    specs.push(['billingRecon', 'bacContext', variables.runId]);
    specs.push(['billingRecon', 'operatorContext', variables.runId]);
  } else {
    specs.push(['billingRecon', 'bacContext']);
    specs.push(['billingRecon', 'operatorContext']);
  }
  scheduleBillingQueryInvalidations(queryClient, specs);
};
